import { render, staticRenderFns } from "./PaymentsDetails.vue?vue&type=template&id=5e9d98e6&lang=pug"
import script from "./PaymentsDetails.vue?vue&type=script&lang=js"
export * from "./PaymentsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports